import { css, keyframes } from 'styled-components';
import {
  MODAL_ANIMATION_DURATION,
  MODAL_ANIMATION_SLIDE_POSITIONS,
} from './constants';

export const ellipsisMultiline = (lines = 2) => `
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const removeScrollbar = () => `
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */

  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

export const getFadeAnimation = (
  isOpen: boolean,
  time: number = MODAL_ANIMATION_DURATION
) => css`
  animation: ${isOpen ? fadeIn : fadeOut} ${time}ms ease-in-out forwards;
`;

export const getMaskIconStyles = (
  filename: string,
  width = 20,
  height = 20
) => `
  width: ${width}px;
  min-width: ${width}px;
  height: ${height}px;
  mask-image: url('/images/${filename}');
  mask-position: center;
  mask-size: contain;
  mask-repeat: no-repeat;
`;

const slideKeyframes = (positions: number[]) => keyframes`
  from {
    transform: translateX(${positions[0]}%);
  }
  to {
    transform: translateX(${positions[1]}%);
  }
`;

export const getSlideAnimation = (
  isOpen: boolean,
  alignment: 'left' | 'right' = 'right',
  time: number = MODAL_ANIMATION_DURATION
) => css`
  animation: ${slideKeyframes(
      MODAL_ANIMATION_SLIDE_POSITIONS[alignment][isOpen ? 'open' : 'close']
    )}
    ${time}ms ease-in-out forwards;
`;

export const centerAbsolute = () => `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
